import { useMemo } from 'react'
import type { InputProps } from '.'
import { normalizeLinkHref } from '../../../forms/fieldTypeDefinitions'
import { dsv } from '../../../styles/defaults'
import { InputText } from './InputText'

export function InputLink({ fieldId, strValue, setStrValue, onBlur, style }: InputProps) {
  const href = useMemo(() => normalizeLinkHref(strValue), [strValue])

  if (setStrValue == undefined) {
    if (href == undefined) {
      return (
        <InputText
          fieldId={fieldId}
          strValue={strValue}
          setStrValue={setStrValue}
          onBlur={onBlur}
          type="url"
          style={style}
        />
      )
    }

    return (
      <a
        id={fieldId}
        href={href}
        target="_blank"
        rel="noreferrer"
        style={{
          display: 'inline-block',
          minHeight: '30px',
          paddingTop: 6,
          ...dsv.text,
          ...style,
          color: dsv.colors.link,
          wordBreak: 'break-word',
        }}
      >
        {strValue}
      </a>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingRight: 8, boxSizing: 'border-box' }}>
      <InputText
        fieldId={fieldId}
        strValue={strValue}
        setStrValue={setStrValue}
        onBlur={onBlur}
        type="url"
        placeholder="https://..."
        style={{ flex: 1, ...style }}
      />
      {href != undefined && (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          style={{
            ...dsv.text,
            color: dsv.colors.link,
            whiteSpace: 'nowrap',
          }}
        >
          Link
        </a>
      )}
    </div>
  )
}
